export enum EmailTag {
  CORE = 'core',
  MARKETING = 'marketing',
  TRANSACTIONAL = 'transactional',
}
